

import addPrefix from 'bwax-ui/addPrefix'

import EntityCard from './EntityCard'

export default addPrefix('design', {
    EntityCard
})